<div class="container-head">
    <div>
        <button type="button" class="btn btn-outline-secondary me-2" (click)="downloadSummary()"><i
                class="bi bi-download"></i>
            {{'Download Summary' | translate }}</button>
    </div>
    <div>{{focusedEntity?.name ?? user.entity.name}}</div>
    <div *ngIf="user.roleId === 1 || (user.roleId === 2 && someHO())">
        <app-basic-virtual-scroll *ngIf="configSvc.currentConfigValue.childEntities" [customTreeNode]="parentEntities"
            [entityType]="4" (callback)="onChange($event,'entity')" [typeData]="action"></app-basic-virtual-scroll>
    </div>
    <div *ngIf="user.roleId === 1 || (user.roleId === 2 && someHO())">
        <div class="btn btn-dark get-packages-pb" (click)="getPackages($event)">
            <i class="bi"
                [ngClass]="{'bi-arrow-clockwise':beforeEntity?.id=== focusedEntity?.id,'bi-arrow-right':beforeEntity?.id!== focusedEntity?.id}"></i>
        </div>
    </div>
</div>
<div class="analytic-package-container">
    <div class="d-flex bd-highlight analytic-package-row">
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'COMMON.TYPE'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.CATEGORY'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">#{{'COMMON.PACKAGES'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.ASSIGNED'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.TEST'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.IN_UPGRADE'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.ACTIVE'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.INACTIVE_REQUEST'|translate}}</div>
        <div class="flex-fill bd-highlight min-width-percent-2-5">
            <div class="analytic-package-row-inactive-info">{{'LICENSE.INACTIVE'|translate}}<hbo-tooltip
                    [target]="'analytic-inactive-legends'"></hbo-tooltip></div>
            <span>IR</span>
        </div>
        <div class="flex-fill bd-highlight min-width-percent-2-5">M</div>
        <div class="flex-fill bd-highlight min-width-percent-2-5">CU</div>
        <div class="flex-fill bd-highlight min-width-percent-2-5">B</div>
    </div>
    <div *ngFor="let item of classification$| keyvalue: compareByKeyDesc">
        <div class="d-flex bd-highlight analytic-package-row">
            <div class="flex-fill bd-highlight analytic-package-row-package-name min-width-percent-11-25">
                {{getPackageName(item.key)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{'Demo'|translate}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,2)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,2,1)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,2,2)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">-</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">-</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">-</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">-</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,2,'M')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">-</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,2,'B')}}</div>
        </div>
        <div class="d-flex bd-highlight analytic-package-row">
            <div class="flex-fill bd-highlight min-width-percent-11-25"></div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{'LICENSE.OPERATIVE'|translate}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,1)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,1,1)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,1,2)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,1,6)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,1,3)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,1,4)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,1,'IR')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,1,'M')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,1,'CU')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,1,'B')}}</div>
        </div>
        <div class="d-flex bd-highlight analytic-package-row analytic-package-row-totals">
            <div class="flex-fill bd-highlight min-width-percent-11-25"></div>
            <div class="flex-fill bd-highlight min-width-percent-11-25"></div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,null,null)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,null,1)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,null,2)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,null,6)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,null,3)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-11-25">{{getTotals(item.key,null,4)}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,null,'IR')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,null,'M')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,null,'CU')}}</div>
            <div class="flex-fill bd-highlight min-width-percent-2-5">{{getTotalsInactive(item.key,null,'B')}}</div>
        </div>
    </div>







</div>